// eslint-disable-next-line no-unused-vars
import { login, logout, getInfo, switchCompany } from '@/api/user'
import { getToken, setToken, removeToken, removeLogoutFlag } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
  token: getToken(),
  ssoToken: '',
  name: '',
  avatar: '',
  introduction: '',
  userInfo: {},
  accountName: localStorage.accountName || '',
  roles: false
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_SSOTOKEN: (state, ssoToken) => {
    state.ssoToken = ssoToken
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERINFO: (state, data) => {
    state.userInfo = data
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USER_NAME: (state, name) => {
    state.accountName = name
    localStorage.setItem('accountName', name)
  }
}

const actions = {
  // user login
  login({ commit, dispatch }, userInfo) {
    const { loginName, password } = userInfo
    return new Promise((resolve, reject) => {
      const params = { loginName: loginName.trim(), password: password }
      if (userInfo.appId) {
        params.appId = userInfo.appId
      }
      if (userInfo.ssoToken) {
        params.ssoToken = userInfo.ssoToken
      }
      login(params).then(async(response) => {
        const { data } = response
        if (data.accessToken) {
          // await dispatch('permission/generateRoutes')
          commit('SET_TOKEN', data.accessToken)
          commit('SET_USER_NAME', data.accountName)
          setToken(data.accessToken)
          removeLogoutFlag()
          resolve(data)
        } else {
          const { data } = response
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  changeCompany({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      switchCompany({ enterpriseId: id }).then(async(response) => {
        const { data } = response
        // await dispatch('permission/generateRoutes')
        commit('SET_TOKEN', data.accessToken)
        commit('SET_USER_NAME', data.accountName)
        setToken(data.accessToken)
        dispatch('getInfo')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { code, data } = response
        if (code === 200) {
          commit('SET_ROLES', true)
          commit('SET_USERINFO', data)
          resolve({})
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }, setToken) {
    return new Promise((resolve, reject) => {
      logout(setToken).then((res) => {
        if (res.code === 200) {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', false)
          // removeToken()
          resetRouter()
          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          commit('home/RESET_STATE', null, { root: true })
          dispatch('tagsView/delAllViews', null, { root: true })
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', false)
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
